var E = /* @__PURE__ */ ((r) => (r.BESIDE = "beside", r.BELOW = "below", r))(E || {}), e = /* @__PURE__ */ ((r) => (r.QUERY = "query", r.URL = "url", r))(e || {}), u = /* @__PURE__ */ ((r) => (r.CHECKBOX = "checkbox", r.RANGE = "range", r))(u || {});
export {
  e as FilterStorage,
  u as FilterTypeEnum,
  E as PriceDetailPosition
};
//# sourceMappingURL=types.js.map
